export enum WitnessTypeEnum {
  Witness = 'witness',
  Buyer = 'buyer',
  Seller = 'seller',
}
